module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-link"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Items")]), _vm._v(" "), _c('div', [(_vm.productItems.length < 1) ? _c('div', [_vm._v("\n            No items attached to this product\n            "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.productItems), function(item) {
    return _c('div', [_c('div', {
      staticClass: "level"
    }, [_c('div', {
      staticClass: "level-left"
    }, [_c('div', {
      staticClass: "level-item"
    }, [(_vm.editingItem === item.id) ? _c('input', {
      staticClass: "input item-count-input",
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": item.count
      },
      on: {
        "input": function($event) {
          _vm.editItemCount = $event.target.value
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.editingItem !== item.id) ? _c('strong', [_vm._v(_vm._s(item.count) + " x")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "level-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'item',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "level-item"
    }, [_vm._v("\n                        -\n                         \n                        "), (_vm.editingItem !== item.id) ? _c('span', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.edit(item)
        }
      }
    }, [_vm._v("Edit")]), _vm._v("\n                             \n                            "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.remove(item)
        }
      }
    })]) : _c('span', [_c('button', {
      staticClass: "button is-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.update(item)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.stopEdit()
        }
      }
    }, [_vm._v("Cancel")])])])])])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.adding) ? _c('div', [_c('a', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.adding = true
      }
    }
  }, [_vm._v("Add item...")])]) : _vm._e(), _vm._v(" "), (_vm.adding) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("How many?")]), _vm._v(" "), _c('input', {
    staticClass: "input item-count-input",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": _vm.newItemCount
    },
    on: {
      "input": function($event) {
        _vm.newItemCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "name": "item-add"
    },
    on: {
      "change": function($event) {
        return _vm.add($event.target.value)
      }
    }
  }, [_c('option', [_vm._v("Select an item...")]), _vm._v(" "), _vm._l((_vm.availableItems), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adding = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37889a76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/products/ProductItems.vue
// module id = 523
// module chunks = 0